import * as React from 'react';
import { styles } from './styles';
import { ColorTypes } from '@joykit/variables/colors';

interface Props {
  error?: boolean;
  noFocus?: boolean;
  subtitles?: Subtitle[];
}

export interface Subtitle {
  content: React.ReactNode;
  color?: ColorTypes;
}

export interface InjectedGroupProps {
  inGroup?: boolean;
  groupFirst?: boolean;
  groupLast?: boolean;
}

export const Group: React.SFC<Props> = ({ children, error, noFocus, subtitles }) => {
  const subtitleComponents: React.ReactNode[] = [];
  if (subtitles) {
    subtitles.forEach(({ content, color }, index) => {
      subtitleComponents.push(
        <div key={`subtitle-${index}`} className={styles.subtitleRow(color)}>
          {content}
        </div>
      );
    });
  }
  return (
    <>
      <div className={`${styles.groupWrapper(error, noFocus)} input-group`}>
        {React.Children.map(children, (child, i) =>
          React.cloneElement(child as JSX.Element, {
            inGroup: true,
            groupFirst: i === 0,
            groupLast: i === React.Children.count(children) - 1
          })
        )}
      </div>
      {subtitleComponents.length > 0 && <div className={styles.subtitlesContainer}>{subtitleComponents}</div>}
    </>
  );
};
